import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useField, ErrorMessage } from 'formik'

// Styled Elements
import { Label, DateInput, FormErrorMessage, FormGroupWrapper, DatePickerWrapper } from './FormDatePicker.elements'

// Views
import { DatePicker } from 'views/components'

function FormDatePicker(props) {
  // Destructure
  const { label, disabled, placeholder, options, ...rest } = props

  const [fields] = useField(props)

  // Variables
  const wrapperRef = useRef()
  const inputRef = useRef(null)
  const { name, value, onChange } = fields

  // Hooks
  const [formValue, setFormValue] = useState('')

  // Functions
  const handleOnChange = async (elValue) => {
    await setFormValue(elValue)
    // manually calling onchange event of formik input through onClick
    inputRef.current.click()
  }

  // UseEffects
  useEffect(() => {
    // setting the value on initial load
    if (value) {
      setFormValue(value)
    }
  }, [value])

  return (
    <DatePickerWrapper label={label} ref={wrapperRef}>
      {label && <Label disabled={disabled}>{label}</Label>}
      <FormGroupWrapper>
        <DateInput
          ref={inputRef}
          onClick={(e) => {
            onChange(e)
          }}
          name={name}
          onChange={() => {}}
          value={formValue}
          type="date"
          disabled={disabled}
          {...rest}
        />
        <DatePicker disabled={disabled} defaultDate={formValue} onApply={handleOnChange} />
        <FormErrorMessage>
          <ErrorMessage {...fields} />
        </FormErrorMessage>
      </FormGroupWrapper>
    </DatePickerWrapper>
  )
}

// Default Props
FormDatePicker.defaultProps = {
  label: '',
  placeholder: '',
  disabled: false,
  options: [],
}

// Proptypes Validation
FormDatePicker.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  options: PropTypes.instanceOf(Array),
}

export default FormDatePicker
